import type { SessionUser } from "~~/server/middleware/auth";

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === "/") {
    return;
  }
  const session = useState<{ _id: string; username: string }>("session");
  if (!session.value?._id) {
    // Just _id, username and primaryEmail, without a database call of its own;
    // the account page fetches the full user from /api/user itself.
    const { data } = await useFetch<SessionUser>("/api/user/session", {
      deep: true
    });
    if (data.value && data.value._id) {
      session.value = data.value;
      console.log("session middleware", session.value);
    } else {
      if (
        to.path === "/" ||
        to.path === "/login" ||
        to.path === "/register" ||
        to.path === "/forgot" ||
        to.path === "/reset" ||
        to.path === "/pricing" ||
        to.path.startsWith("/viewer/case") ||
        to.path.startsWith("/viewer/playlist") ||
        to.path.startsWith("/c/")
      ) {
        return;
      }
      return navigateTo("/login");
    }
  }
});
